import ProjectHeaderLocalSettings from "../../../local-settings";

export default function header_toggleIsCompact(projectId: ID) {
    const localSettings = new ProjectHeaderLocalSettings()

    const newValue = !localSettings.isSubmenuCompact(projectId)
    localSettings.setSubmenuCompact(projectId, newValue)
    localSettings.save()

    gd.bus.triggerEvent('toggle-submenu')

    return localSettings
}